import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export function useGetRecipeImage(path?: string | null) {
    const { data, isPending, isError } = useQuery({
        queryKey: ["recipe-image", path],
        queryFn: async () => {
            if (!path) return null;
            const { data } = await supabase.storage.from("recipe-images").createSignedUrl(path, 5 * 60); // URL valid for 5 minutes
            return data?.signedUrl ?? null;
        },
        enabled: !!path,
        staleTime: 5 * 60 * 1000 // 5 minutes
    });

    return { imageUrl: data, isPending, isError };
}
